import { schAloftPrice } from '@aloft/toolkit-shared';

import { z } from 'zod';

export const schReconciliationSheetForm = z
  .object({
    totalCostToCure: schAloftPrice,
    totalRenovationBudget: schAloftPrice,
    opinionOfMarketValue: schAloftPrice,
    opinionOfAfterRepairValue: schAloftPrice,
    reconciliationCommentary: z.string(),
    aivReconciliationCommentary: z.string(),
    arvReconciliationCommentary: z.string(),
  })
  .partial();
export type ReconciliationSheetFormOutput = z.infer<typeof schReconciliationSheetForm>;
export type ReconciliationSheetForm = typeof schReconciliationSheetForm;
